
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'

export default {
  extends: CardPropertyObjectCustom,
  methods: {
    enrichComponentProps: function (componentProps) { // @Override
      componentProps.url = '/service/delta/employee/getWorkAreaPropertyValues'
      componentProps.select = true
      componentProps.cached = false
      componentProps.objectsMapper = workArea => {
        let disabled = false
        let reasonDisabled
        if (this.object.mainWorkAreaSchedule && this.object.mainWorkAreaSchedule.workAreas) {
          this.object.mainWorkAreaSchedule.workAreas.forEach((workAreaScheduleKeys, index) => {
            const now = new Date().getTime()
            if (workAreaScheduleKeys.includes(workArea.key)) {
              if (this.object.mainWorkAreaSchedule.endTime && this.object.mainWorkAreaSchedule.endTime[index] && now < this.object.mainWorkAreaSchedule.endTime[index]) {
                disabled = true
              }
            }
          })
        }
        if (disabled) {
          reasonDisabled = 'Сотрудник будет переведён в этот отдел'
        } else if (workArea.hasBaseAccess === false) {
          disabled = true
          reasonDisabled = 'Нет доступа'
        }
        return {
          ...workArea,
          _disabled: disabled,
          _reasonDisabled: reasonDisabled
        }
      }
    }
  }
}
